export default "__VITE_ASSET__3bd56afa__"